import React from "react";
import { noop } from "@common/helpers/function";
import { TaskPriority } from "@common/types/task";
import { TASK_PRIORITY_CONFIG } from "@components/tasks/TaskPrioritySelect/taskPriority.constant";
import { TaskPriority as TaskPriorityLabel } from "@components/tasks/TaskPrioritySelect/TaskPriority";
import { FilterActionsFooter } from "@design-system/Filter/FilterActionsFooter/FilterActionsFooter";
import {
    FilterMultiselect,
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

const allPriorities = Object.values(TaskPriority);

const isTaskPriority = (value: FilterMultiselectValue): value is TaskPriority =>
    typeof value === "string" &&
    allPriorities.some((priority) => priority === value);

const options: FilterMultiselectOption[] = allPriorities.map((priority) => ({
    value: priority,
    label: <TaskPriorityLabel priority={priority} variant="full" />,
    searchableLabel: TASK_PRIORITY_CONFIG[priority].label,
}));

export const TaskPriorityFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value = filters.taskPriorities ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const selected = val.filter(isTaskPriority);
                    onChange({
                        taskPriorities: selected.length ? selected : undefined,
                    });
                }}
                name="taskPriorities"
                onBlur={noop}
            />
            {!!filters.taskPriorities?.length && (
                <FilterActionsFooter
                    deselectFunction={() =>
                        onChange({ taskPriorities: undefined })
                    }
                    selectedCount={filters.taskPriorities.length}
                />
            )}
        </div>
    );
};
